const { render } = require("sass");

function setPlatformConfiguration() {
  Tagalys.setPlatformConfiguration({
    platform: "Shopify",
    countryCode: "GB",
    baseCountryCode: "GB",
    useStorefrontAPIForSecondaryMarkets: true,
    waitForStorefrontAPI: true,
    storefrontAPI: {
      accessToken: "21a104606007a70d7cf1c30230a54275",
      myShopifyDomain: "pretty-green-store.myshopify.com",
    },
    metafields: {
      products: [],
    },
  });
}

async function initSearchFlow() {
  const shopifySearchGrid = document.querySelector("[shopify-search]");
  const products_per_page = 25;

  setPlatformConfiguration();

  initTagalysSearch(shopifySearchGrid, products_per_page);

  await safeCallSearchResults(); // ← This happens after Tagalys is initialized
}

function renderProductCards(products, append = false) {
  const productCardSection = "pg-product-card";
  const productsFragment = document.createDocumentFragment();

  if (products.length > 0) {
    // Collect all fetch promises
    const fetchPromises = products.map((product) => {
      const handle = product.handle;

      return fetch(window.Shopify.routes.root + `products/${handle}?section_id=${productCardSection}`)
        .then(response => {
          if (!response.ok) throw new Error("Error: " + response.status);
          return response.text();
        })
        .then(data => {
          const htmlDocument = new DOMParser().parseFromString(data, "text/html");
          const productCard = htmlDocument.documentElement.querySelector("[product-card]");
          return productCard; // Return the product card
        })
        .catch(error => {
          console.error("Error fetching product card:", error);
          return null; // Return null if there's an error
        });
    });

    // Wait for all fetches to complete and preserve order
    Promise.all(fetchPromises).then((productCards) => {
      productCards.forEach((productCard) => {
        if (productCard) {
          productsFragment.appendChild(productCard);
        }
      });
      addProductFragmentToGrid(productsFragment, append);
    });
  }
}

// await
function addProductFragmentToGrid(fragment, append = false) {
  const tagalysSearchGrid = document.querySelector("[tagalys-search-grid]");

  if (!tagalysSearchGrid) return;

  // Clear existing content only if filters and not next page
  if (!append) {
    tagalysSearchGrid.innerHTML = "";
  }

  tagalysSearchGrid.appendChild(fragment);
}

// Display invalid search message to user
function displayInvalidSearchMessage(query,originalQuery) {
  const invalidSearchMessage = document.querySelector("[invalid-search]");
  if (invalidSearchMessage) {
    const invalidSearchTerm = invalidSearchMessage.querySelector("[invalid-search-term]");
    if (invalidSearchTerm) {
      invalidSearchMessage.style.display = "block";
      invalidSearchTerm.innerHTML = query;
    }
  } else {
    console.warn("Invalid search message element not found.");
  }
}

function renderFilters(filters) {
  if (!filters) return;
  const filterForm = document.querySelector("[tagalys-search-filter-form]");
  if (!filterForm) return;

  filterForm.innerHTML = ''; //we need to clear it if we reload it

  filters.forEach((filter) => {
    console.log("Filter:", filter);
    const filterElement = document.createElement("div");
    filterElement.classList.add("custom-filter");

    // Heading
    const filterHeading = document.createElement("div");
    filterHeading.classList.add("filter-heading");
    filterHeading.innerHTML = filter.name;
    filterHeading.innerHTML += `<svg xmlns="http://www.w3.org/2000/svg" width="15.403" height="8.806" viewBox="0 0 15.403 8.806"><path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M6.152,7.7.323,1.876A1.1,1.1,0,0,1,1.882.322l6.6,6.6a1.1,1.1,0,0,1,.032,1.518L1.887,15.082A1.1,1.1,0,0,1,.328,13.528Z" transform="translate(15.403) rotate(90)"></path></svg>`;

    // Body
    const filterBody = document.createElement("div");
    filterBody.classList.add("filter-body");
      // Checkboxes
      if (filter.type === "checkbox") {
        filter.items.forEach((item) => {
          let checked = item.selected ? "checked" : "";
          
          // Label HTML
          const labelHTML = `<label for="${item.id}">
                              <input type="checkbox" name="${filter.id}" value="${item.id}" id="${item.id}" ${checked}>
                                <span class="custom-check">
                                  <svg class="check" viewBox="0 0 448 512">
                                    <path d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"></path>
                                  </svg>
                                </span>
                                ${item.name} (${item.count})
                              </label>`;

          filterBody.innerHTML += labelHTML;
        });
      }

      filterElement.appendChild(filterHeading);
      filterElement.appendChild(filterBody);

      filterForm.appendChild(filterElement);
    });
}

//check the filter checkboxes and add them as required to object before passing to Tagalys
function getCheckedFilters() {
  const filterForm = document.querySelector("[tagalys-search-filter-form]");
  if (!filterForm) return;
  const checkboxes = filterForm.querySelectorAll("input[type='checkbox']");
  const selectedFilters = {};

  checkboxes.forEach((checkbox) => {
    const group = checkbox.name;
    const value = checkbox.value;

    if (checkbox.checked) {
      if (!selectedFilters[group]) selectedFilters[group] = [];
      selectedFilters[group].push(value);
    }
  });

  console.log(selectedFilters);

  window.searchResultsInstance.helpers.clearAllFilters();

  for (const [facet, values] of Object.entries(selectedFilters)) {
    window.searchResultsInstance.helpers.applyFilter(facet, values);
  }
}

function addFiltersToURL(filters) {
  const currentParams = new URLSearchParams(window.location.search);

  console.log('Adding to URL');

  filters.forEach(filter => {
      filter.items.forEach(item => {
          if (item.selected) {
              currentParams.append(`filter.${filter.id}`, item.name);
          }
      });
  });

  const newUrl = `${window.location.pathname}?${currentParams.toString()}`;

  window.history.pushState({}, '', newUrl);
}

if (window.innerWidth >= 768) {
  document.addEventListener("change", function (event) {
    console.log(event);
      getCheckedFilters();
  });
} else {
    document.querySelector('#apply-tagalys-filters').addEventListener("click", function (event) {
      getCheckedFilters();
  });
}

function applyFilters() {
  const filterForm = document.querySelector("[tagalys-search-filter-form]");
  if (!filterForm) return;
  const apply_btn = document.querySelector("#apply-tagalys-filters");
  if (!apply_btn) return;
  apply_btn.addEventListener("click", function () {
    console.log("Apply filters clicked");
    window.searchResultsInstance.helpers.applyFilter("p.m.filters.category", "polos");
  });
}
// Open filter on click
function openFilter() {
  document.addEventListener("click", function (event) {
    const filterHeading = event.target.closest("[tagalys-search-filter-form] .filter-heading");
    const customFilters = document.querySelectorAll("[tagalys-search-filter-form] .custom-filter");
    if (filterHeading) {
      const filterBody = filterHeading.closest(".custom-filter");
      if (filterBody.classList.contains("open")) {
        filterBody.classList.remove("open");
      } else {
        customFilters.forEach((filter) => {
          filter.classList.remove("open");
        });
        filterBody.classList.add("open");
      }
    } else {
      customFilters.forEach((filter) => {
        filter.classList.remove("open");
      });
    }
  });
}

function openMobileFilter() {
  let mobile_control = document.querySelector(".filter-container-wrapper.tagalys-search-filters .mobile-filter-heading")
  let filter_body = document.querySelector(".filter-container-wrapper.tagalys-search-filters .custom-filter-wrapper")

  if(mobile_control && filter_body){
      mobile_control.addEventListener('click', () => {
          console.log('clicked');

          // rotate svg
          if(mobile_control.classList.contains("open")){
              mobile_control.classList.remove("open")
          } else {
              mobile_control.classList.add("open")
          }

          // open filters
          if(filter_body.classList.contains("open")){
              filter_body.classList.remove("open")
          } else {
              filter_body.classList.add("open")
          }
      })
  }
}

function initTagalysSearch(shopifySearchGrid, products_per_page, filters, sort_by) {
  const urlParams = new URLSearchParams(window.location.search);
  const searchQuery = urlParams.get("q");

  if (!searchQuery) {
    console.warn("No search query found in the URL");
    return;
  }

  if (
    !window.Tagalys ||
    !Tagalys.APIConnector
  ) {
    console.error("Tagalys APIConnector is not loaded.");
    if (shopifySearchGrid) {
      shopifySearchGrid.classList.add("show");
    }
    return;
  }

  try {
    window.searchResultsInstance = Tagalys.APIConnector.SearchResults.new({
      params: {
        query: searchQuery,
        perPage: products_per_page
      },
      onSuccess: function(response, helpers){
        console.log("response", response);
        console.log("helpers", helpers);

        if (helpers.isRedirected()) {
          const redirectURL = helpers.getRedirectURL();
          if (redirectURL) {
            window.location.href = redirectURL;
          }
          return;
        }

        if (!helpers.isValidQuery()) {
          const originalQuery = helpers.getOriginalQuery();
          const query = helpers.getQuery();
          displayInvalidSearchMessage(query,originalQuery);
        }

        console.log("Get filters:", helpers.getFilters());
        console.log("Get applied filters:", helpers.getAppliedFilters());
        console.log("Get sort:", helpers.getSortOptions());

        if(helpers.getAppliedFilters().length > 0) {
          addFiltersToURL(helpers.getAppliedFilters());
        }

        renderFilters(helpers.getFilters());

        const isNextPage = response.page > 1;
        renderProductCards(response.products, isNextPage);

        const count = response.total;
        const totalEl = document.querySelector("[search-results-count]");
        if (totalEl) {
          totalEl.innerHTML = count;
        }

        const page = response.page;
        const totalPages = response.total_pages;

        const loadMoreButton = document.querySelector("[tagalys-load-more]");
        const load_more_spinner = document.querySelector("[tagalys-load-more] .load-more-spinner");

        setTimeout(() => {
          load_more_spinner.classList.remove('show');
        }, 250);

        if (loadMoreButton) {
          if (page < totalPages) {
            loadMoreButton.style.display = "flex";
          } else {
            loadMoreButton.style.display = "none";
          }
        }
        // Called after a successful API call
        // Use response to render the results - described below
      },
      onFailure: function(response, helpers){
        // Called after a failed API call
        if (shopifySearchGrid) {
          shopifySearchGrid.classList.add("show");
        }
      }
    });
  } catch (err) {
    if (shopifySearchGrid) {
      shopifySearchGrid.classList.add("show");
    }
    console.error("Error initializing Tagalys search:", err);
  }

  // Call the search instance to fetch results
  safeCallSearchResults();
}

async function safeCallSearchResults() {
  await new Promise(resolve => setTimeout(resolve, 100)); // wait 100ms

  if (
    window.searchResultsInstance &&
    typeof window.searchResultsInstance.helpers?.call === 'function'
  ) {
    try {
      await window.searchResultsInstance.helpers.call();
      console.log('SearchResultsInstance call completed');
    } catch (error) {
      console.error('Error during searchResultsInstance.helpers.call():', error);
    }
  } else {
    console.warn('searchResultsInstance.helpers.call is not available yet');
  }
}

// Wait for DOM + Tagalys to be fully ready
document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    if (
      window.Tagalys &&
      Tagalys.APIConnector &&
      Tagalys.APIConnector.SearchResults
    ) {
      clearInterval(interval);
      initSearchFlow();
    }
  }, 100);

  openFilter();
  applyFilters();

  if (window.innerWidth <= 768) {
    openMobileFilter(); 
  }

  const load_more = document.querySelector("[tagalys-load-more]");
  const load_more_spinner = document.querySelector("[tagalys-load-more] .load-more-spinner");
  if (load_more) {
    load_more.addEventListener("click", function () {
      window.searchResultsInstance.helpers.goToNextPage();
      load_more_spinner.classList.add('show');
    });
  }
});
